let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page017_game12/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 259,
      y: 138,
    },
  },
  activeArea: {
    width: 60,
    height: 60,
    fontSize: 39,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Wciśnij kolejno <br/>i przytrzymaj klawisze Ctrl (Control) i C, <br/>aby skopiować obrazek.  ',
      },
      audio: {
        src: 'games/page017_game12/audio/z8s17-b1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 684,
        y: 376,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Wciśnij kolejno <br/>i przytrzymaj klawisze Ctrl (Control) i V, <br/>aby wkleić obrazek.',
      },
      audio: {
        src: 'games/page017_game12/audio/z8s17-b2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1264,
        y: 796,
      },
    },
  ],
};
export default elements;
